// extracted by mini-css-extract-plugin
export default {"container":"Wfa-z","mediaElement":"Xfa-z","close":"Yfa-z"};